import { useState, useEffect } from "react";
import { Modal, Button, Form, Input, Spin } from "antd";
import { withRouter } from "react-router";
import { getConstantById, updateConstantById } from "@api/workspace/constant";
import { SuccessNotification, ErrorNotification } from "../..";

const initialState = {
  name: "",
  value: "",
};

const ConstantUpdateModal = ({
  open,
  handleModalClick,
  fetchConstants,
  constantId,
}) => {
  const [values, setValues] = useState(initialState);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Fetch constant by id
    fetchConstantById();
  }, []);

  // Handle fetch constant by id
  const fetchConstantById = async () => {
    setLoading(true);
    try {
      const { data } = await getConstantById(constantId);

      setValues(data);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.log("GET_CONSTANT_BY_ID_ERROR", err);
    }
  };

  // Handle form change
  const handleFormChange = (e) => {
    e.preventDefault();
    setValues({
      ...values,
      [e.target.name]: e.target.value,
    });
  };

  // Handle constant update
  const handleConstantUpdate = async (e) => {
    setLoading(true);
    e.preventDefault();

    // Update constant
    updateConstantById(constantId, values)
      .then(() => {
        setValues(initialState);
        handleModalClick();
        fetchConstants();
        SuccessNotification("Constant updated successfully");
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        ErrorNotification(err.response.data.message);
      });
  };

  return (
    <>
      <Modal
        title="Update Constant"
        visible={open}
        onOk={handleModalClick}
        closable={false}
        width={600}
        footer={[
          <Button key="back" onClick={handleModalClick}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            onClick={handleConstantUpdate}
            loading={loading}
          >
            Update
          </Button>,
        ]}
      >
        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "calc(80vh - 50px)",
            }}
          >
            <Spin />
          </div>
        ) : (
          <Form
            labelCol={{
              span: 5,
            }}
            wrapperCol={{
              span: 16,
            }}
          >
            {/* Constant Name */}
            <Form.Item label="Name">
              <Input
                name="name"
                placeholder="Enter constant name"
                onChange={handleFormChange}
                value={values.name}
                rules={[{ required: true }]}
              />
            </Form.Item>

            {/* Constant Value */}
            <Form.Item label="Value">
              <Input
                name="value"
                placeholder="Enter constant value"
                onChange={handleFormChange}
                value={values.value}
                rules={[{ required: true }]}
              />
            </Form.Item>
          </Form>
        )}
      </Modal>
    </>
  );
};

export default withRouter(ConstantUpdateModal);
